<template>
  <b-modal
    id="reactivate-subscription"
    ref="reactivate-subscription"
    size="invite-member"
    centered
    hide-footer
    hide-header
    @hide="close"
  >
    <div class="modal-head seats">
      <h2 class="modal-title">
        {{ label.get('reactivate_subscription') }}?
      </h2>
    </div>
    <div class="content-wrapper">
      <p class="seats-desc">
        {{ label.get('subscription_reactivate_description') }}
      </p>
    </div>
    <div class="modal-footer">
      <div class="form-buttons">
        <button
          type="reset"
          class="atto-btn cancel"
          @click="close"
        >
          {{ label.get('cancel') }}
        </button>
        <button
          type="submit"
          class="atto-btn submit"
          @click="reactivate"
        >
          {{ label.get('confirm') }}
        </button>
      </div>
    </div>
  </b-modal>
</template>

<script>
    import BillingService from '../services/BillingService';
    export default {
        name: "ReactivateSubscriptionComponent",
        data() {
            return {
                disabled: false
            };
        },
        mounted() {
            document.body.appendChild(this.$el);
            this.$refs['reactivate-subscription'].show();
        },
        methods: {
            reactivate() {
                this.disabled = true;
                this.$store.commit('showLoading');
                BillingService.resumeSubscription().then((result) => {
                    this.disabled = false;
                    this.$store.commit('hideLoading');
                    this.$root.$emit('hideReactivateSubscription', true);
                }).catch((error) => {
                    this.disabled = false;
                    this.$store.commit('hideLoading');
                });
            },

            close() {
                this.$root.$emit('hideReactivateSubscription');
            }
        }
    }
</script>
